const browserLocation = {
  reload(forceReload) {
    global.location.reload(forceReload);
  },
  assign(url) {
    global.location.assign(url);
  }
};
export default browserLocation;